import { render, staticRenderFns } from "./full-show.vue?vue&type=template&id=30941908"
import script from "./full-show.js?vue&type=script&lang=js&external"
export * from "./full-show.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports